import { render, staticRenderFns } from "./ServiceInfor.vue?vue&type=template&id=816105c0&"
import script from "./ServiceInfor.vue?vue&type=script&lang=js&"
export * from "./ServiceInfor.vue?vue&type=script&lang=js&"
import style0 from "./ServiceInfor.vue?vue&type=style&index=0&id=816105c0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports